import { render, staticRenderFns } from "./applyPromo.vue?vue&type=template&id=005a5626&"
import script from "./applyPromo.vue?vue&type=script&lang=js&"
export * from "./applyPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports